module.exports = __webpack_public_path__ + "static/img/112.1c13399.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/112.jpg
// module id = Z3H/
// module chunks = 2